<template>
	<div class="reservation-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">服务预约</h1>
            <p class="page-subtitle">我的预约记录</p>
        </div>

        <!-- 预约列表 -->
        <div class="reservation-list">
            <div 
                class="reservation-card" 
                v-for="item in orderList" 
                :key="item.apporder"
                @click="itemClick(item.apporder)"
            >
                <div class="card-header">
                    <div class="order-left">
                        <van-icon name="orders" class="order-icon" />
                        <span class="order-number">{{ item.apporder }}</span>
                    </div>
                    <van-tag :type="getStatusType(item.status)" class="status-tag">
                        {{ item.status }}
                    </van-tag>
                </div>
                
                <div class="card-content">
                    <div class="info-item">
                        <van-icon name="location" class="content-icon" />
                        <span class="info-text">{{ item.appplace }}</span>
                    </div>
                    <div class="info-item">
                        <van-icon name="clock" class="content-icon" />
                        <span class="info-text">预约时间：{{ item.Appdate }}</span>
                    </div>
                </div>
                <van-icon name="arrow" class="arrow-icon" />
            </div>
        </div>

        <!-- 空状态 -->
        <div v-if="orderList.length === 0" class="empty-state">
            <van-empty description="暂无预约记录" image="orders">
                <van-button 
                    round 
                    type="primary" 
                    class="new-reservation-btn"
                    @click="newOrder"
                >
                    新建预约
                </van-button>
            </van-empty>
        </div>

        <!-- 底部新建按钮 -->
        <div class="footer-action">
            <van-button 
                type="primary" 
                size="large" 
                class="new-reservation-btn"
                @click="newOrder"
            >
                <van-icon name="add" class="btn-icon" />
                新建预约
            </van-button>
        </div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import Vue from 'vue'	
	import {Dialog} from 'vant'	
	
	export default {
	  name: 'REVERVATION',	 
	  data(){
	  	return{	
            orderList:[],
            reserve: require("@/assets/newsr.png")
        }
	  },	  
	  created(){
         this.getApporders('');
	  },
	  mounted(){
        document.title = '服务预约';  
      },
	  methods:{
        getStatusType(status) {
            const statusMap = {
                '待处理': 'warning',
                '已确认': 'success',
                '进行中': 'primary',
                '已完成': 'success',
                '已取消': 'danger'
            }
            return statusMap[status] || 'default'
        },
		newOrder(){
            this.$router.push({ path:'/reserve/order'  })
        },		
        getApporders(orderid){
            var that = this;
            var access_token =  localStorage['access_token'];
            var myUrl = that.global.BASE_URL_T3 + '/api/pdsm/myapporders?apporderid=' + orderid;				
            var config = {
                method: 'get',
                url: myUrl,
                headers: { 
                    'Authorization': access_token
                }
            };
            
            Vue.axios(config)
            .then(function (response) {		
                console.log(response.data)		  
                if (response.data.Status == 0) {
                    that.orderList = response.data.Data;
                }		
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        itemClick(e){
            console.log(e)
            this.$root.common.curorderid = e;
            this.$router.push('reserve/orderdetail');
        },
        onClickLeft(){
            this.$router.push({ path:'/'  })
        }
	  }
	}
</script>

<style scoped>
.reservation-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.page-header {
    background-color: #ffffff;
    padding: 20px 16px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
}

.page-title {
    font-size: 18px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 4px;
}

.page-subtitle {
    font-size: 14px;
    color: #969799;
    margin: 0;
}

.reservation-list {
    padding: 16px;
}

.reservation-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
}

.reservation-card:active {
    background-color: #f5f5f5;
    transform: scale(0.98);
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5f5f5;
}

.order-left {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
}

.order-icon {
    color: #1989fa;
    font-size: 18px;
    margin-right: 8px;
    flex-shrink: 0;
}

.order-number {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    line-height: 1.4;
    word-break: break-all;
}

.status-tag {
    margin-left: 8px;
    flex-shrink: 0;
}

.card-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-right: 20px;
}

.info-item {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    color: #646566;
    text-align: left;
}

.content-icon {
    color: #969799;
    font-size: 14px;
    margin-right: 8px;
    width: 16px;
    flex-shrink: 0;
    margin-top: 2px;
}

.info-text {
    line-height: 1.4;
    flex: 1;
    text-align: left;
    word-break: break-all;
}

.arrow-icon {
    color: #969799;
    font-size: 14px;
    position: absolute;
    right: 16px;
    bottom: 16px;
}

.empty-state {
    padding: 60px 20px;
}

.footer-action {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
}

.new-reservation-btn {
    border-radius: 8px;
}

.btn-icon {
    margin-right: 4px;
}
</style>